export default {
  locations: null,
  messageSendingStatus: null,
  isMobile: false,
  parentWidth: null,
  parentHeight: null,
  customSettings: {}
}
